import { Dayjs } from 'dayjs';
import { createGlobalStyle } from 'styled-components';
import useP4RContext from '@/store/P4RContext';

// Helper function to get the 6-hour block suffix
const getTimeBlockSuffix = (currentTimeDate: Dayjs | null): string => {
  const hour = currentTimeDate?.hour();
  if (!hour) return '0';
  if (hour < 6) return '0';
  if (hour < 12) return '6';
  if (hour < 18) return '12';
  return '18';
};

// Create the global style component
const GlobalStyle = createGlobalStyle<{
  currentTime: [Dayjs | null, number, number?];
  currentTimeComparison: [Dayjs | null, number, number?];
}>`
  ${({ currentTime, currentTimeComparison }) => {
    const [currentTimeDate] = currentTime;
    const [currentTimeDateComparison] = currentTimeComparison;

    const dateString = currentTimeDate?.format('YYYY-MM-DD');
    const timeBlockSuffix = getTimeBlockSuffix(currentTimeDate);

    const dateStringComparison =
      currentTimeDateComparison?.format('YYYY-MM-DD');
    const timeBlockSuffixComparison = getTimeBlockSuffix(
      currentTimeDateComparison,
    );

    return `
      .table-cell-${dateString},
      .table-cell-${dateString}-${timeBlockSuffix},
      .table-cell-comparison-${dateStringComparison},
      .table-cell-comparison-${dateStringComparison}-${timeBlockSuffixComparison} {
        background-color: #ffffff !important;
      }
      th.table-cell-${dateString},
      th.table-cell-comparison-${dateStringComparison} {
        position: relative;
        &:after {
          content: '';
          display: block;
          width: 0px;
          height: 0px;
          border-top : 5px solid var(--ant-color-text);
          border-right : 5px solid transparent;
          border-left : 5px solid transparent;
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    `;
  }}
`;

function CurrentTimeGlobalStyles() {
  const P4RContext = useP4RContext();
  const { currentTime, currentTimeComparison } = P4RContext;

  return (
    <GlobalStyle
      currentTime={currentTime}
      currentTimeComparison={currentTimeComparison}
    />
  );
}

export default CurrentTimeGlobalStyles;
